/* unplugin-vue-components disabled */import { render } from "./UserAccountDeleteDialog.vue?vue&type=template&id=498a7a85&ts=true"
import script from "./UserAccountDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./UserAccountDeleteDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__